module.exports = __webpack_public_path__ + "acc7448b80728a73c9a4046b3ec4407f.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?esModule=false!./~/ace-builds/src-noconflict/snippets/golang.js
// module id = 836
// module chunks = 1